import Alpine from 'alpinejs';
import { PhotosList } from './pages/list';

Alpine.data(
    'photosList',
    (pageId: PageId, pageNumber: number, tag?: string) => new PhotosList(pageId, pageNumber, tag)
);
